import React from 'react'
import Transaction from "./Transaction";
import TradingViewWidget from 'react-tradingview-widget';
import "../App.css";
import {useHistory} from "react-router-dom";

function TradeComp() {

  const history = useHistory();
  
  return (
    <div className="trade_grid_chart">
			
            <div className='trade_grid_comp'>
                  <h4>SMA Strategy</h4>
                  <div className="tradechart">
                  <TradingViewWidget
                    symbol="BSE:HDFC"
                    className="tradechart"
                    height="250"
                    width="250"
                />
                </div>
                <h4 onClick={()=>history.push("/st_desc/sma")}className='exe_button'>Execute</h4>
            </div>
            <div className='trade_grid_comp'>
                  <h4>RSI Strategy</h4>
                  <div className="tradechart">
                  <TradingViewWidget
                    symbol="BSE:SBIN"
                    className="tradechart"
                    height="250"
                    width="250"
                />
                </div>
                <h4 onClick={()=>history.push("/st_desc/rsi")} className='exe_button'>Execute</h4>
            </div>
            <div className='trade_grid_comp'>
                  <h4>Volume Up Strategy</h4>
                  <div className="tradechart">
                  <TradingViewWidget
                    symbol="BSE:SBIN"
                    className="tradechart"
                    height="250"
                    width="250"
                />
                </div>
                <h4 className='exe_button'>Execute</h4>
            </div>
            <div className='trade_grid_comp'>
                  <h4>Volume Up Strategy</h4>
                  <div className="tradechart">
                  <TradingViewWidget
                    symbol="BSE:SBIN"
                    className="tradechart"
                    height="250"
                    width="250"
                />
                </div>
                <h4 className='exe_button'>Execute</h4>
            </div>
            <div className='trade_grid_comp'>
                  <h4>Inside Strategy</h4>
                  <div className="tradechart">
                  <TradingViewWidget
                    symbol="BSE:SBIN"
                    className="tradechart"
                    height="250"
                    width="250"
                />
                </div>
                <h4 className='exe_button'>Execute</h4>
            </div>
            <div className='trade_grid_comp'>
                  <h4>VWAP Strategy</h4>
                  <div className="tradechart">
                  <TradingViewWidget
                    symbol="BSE:SBIN"
                    className="tradechart"
                    height="250"
                    width="250"
                />
                </div>
                <h4 className='exe_button'>Execute</h4>
            </div>
    

		</div>

  )
}

export default TradeComp


